import { createContext, useContext, useEffect, useRef, useState } from "react";

const RadioContext = createContext(null);

export function RadioProvider({ children }) {
  const audioRef = useRef(null);
  const [status, setStatus] = useState("idle"); // idle | loading | playing | error
  const [volume, setVolumeState] = useState(0.8);
  const [station, setStation] = useState("Web Rádio Clássicos do Funk");

  useEffect(() => {
    const audio = new Audio();
    audio.preload = "none";
    audio.volume = 0.8;
    audioRef.current = audio;
    const onPlaying = () => setStatus("playing");
    const onPause = () => setStatus((s) => (s === "error" ? s : "idle"));
    const onError = () => setStatus("error");
    audio.addEventListener("playing", onPlaying);
    audio.addEventListener("pause", onPause);
    audio.addEventListener("error", onError);

    fetch("/content/site.json")
      .then((r) => r.json())
      .then((site) => {
        audio.src = site.radio.streamUrl;
        setStation(site.radio.name);
      })
      .catch(() => setStatus("error"));

    return () => {
      audio.pause();
      audio.removeEventListener("playing", onPlaying);
      audio.removeEventListener("pause", onPause);
      audio.removeEventListener("error", onError);
    };
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio || !audio.src) return;
    if (status === "playing" || status === "loading") {
      audio.pause();
      setStatus("idle");
      return;
    }
    setStatus("loading");
    audio.play().catch(() => setStatus("error"));
  };

  const setVolume = (v) => {
    setVolumeState(v);
    if (audioRef.current) audioRef.current.volume = v;
  };

  return (
    <RadioContext.Provider value={{ status, toggle, volume, setVolume, station }}>
      {children}
    </RadioContext.Provider>
  );
}

export function useRadio() {
  return useContext(RadioContext);
}
